export const state = () => ({
  value: {},
  // Action keeps type and value - what we want do do from context menu
  action: {},
});

export const mutations = {
  changeValue(state, value) {
    state.value = value;
  },
  changeAction(state, value) {
    state.action = value;
  },
};

export const actions = {
  open({ commit, state, dispatch }, value) {
    if (state.value.component) dispatch('close');
    if (value.component) {
      commit('changeValue', value);
    }
  },
  close({ commit, state }) {
    if (state.component) state.component.destroy();
    commit('changeValue', {});
  },
  addAction({ commit }, value) {
    commit('changeAction', value);
  },
  removeAction({ commit }) {
    commit('changeAction', {});
  },
};

export default { namespaced: true, state, mutations, actions };
